import type { AuthSession } from './types';

// Derived, never stored, so it can't drift from the token fields.
export const selectIsAuthenticated = (session: AuthSession): boolean =>
	session.accessToken !== null;
